export default __webpack_public_path__ + "static/media/BG_Page_06.f6be5102.svg";